import SEO, { pageSEO } from "../components/seo.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faHouse,
  faDollarSign,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { fadeUp, stagger } from "../functions/animations";


export default function Calculator() {

  const seoConfig = pageSEO.calculator();

  const cards = [
    {
      icon: faCalculator,
      title: "Estimate Payments",
      text: "Calculate your expected monthly mortgage payments and understand your affordability."
    },
    {
      icon: faDollarSign,
      title: "Plan Your Budget",
      text: "Explore different down payments, rates, and loan terms before making decisions."
    },
    {
      icon: faHouse,
      title: "Smart Home Buying",
      text: "Know your numbers and approach your next purchase with confidence."
    }
  ];

  return (
    <>
      <SEO {...seoConfig} />

      {/* HERO */}
      <section className="relative overflow-hidden bg-cottage-secondary pt-40 pb-28">

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true
          }}
          className="relative mx-auto max-w-6xl px-6 text-center">
          <motion.p
            variants={fadeUp}
            className="uppercase tracking-[0.45em] text-sm font-semibold text-cottage-accent">
            Financial Tools
          </motion.p>

          <motion.h1
            variants={fadeUp}
            className="mt-6 font-serif text-5xl leading-none text-cottage-primary lg:text-7xl">
            Mortgage
            <br />
            Calculator
          </motion.h1>

          <motion.p
            variants={fadeUp}
            className="mx-auto  max-w-3xl text-lg leading-8 text-cottage-muted">
            Estimate your monthly mortgage payments and understand
            what fits comfortably within your budget before purchasing
            your next home.
          </motion.p>
        </motion.div>
      </section>

      {/* FEATURES */}
      <section className="mx-auto max-w-[1400px] px-6 -mt-10 relative z-10">
        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true
          }}
          className="grid gap-6 md:grid-cols-3"
        >
          {
            cards.map((card, index) => (
              <motion.div
                key={index}
                variants={fadeUp}
                whileHover={{
                  y: -8
                }}
                className="rounded-lg bg-white p-8 shadow-xl border border-cottage-border"
              >
                <div className="flex h-14 w-14 items-center justify-center rounded-full bg-cottage-secondary
              ">
                  <FontAwesomeIcon
                    icon={card.icon}
                    className="text-2xl text-cottage-accent"
                  />
                </div>

                <h3 className="mt-7 font-heading text-3xl text-cottage-primary">
                  {card.title}
                </h3>

                <p className="mt-4 leading-7 text-cottage-muted">
                  {card.text}
                </p>
              </motion.div>
            ))
          }
        </motion.div>
      </section>

      {/* CALCULATOR */}
      <motion.section
        variants={fadeUp}
        initial="hidden"
        whileInView="visible"
        viewport={{
          once: true
        }}
        className="mx-auto max-w-[1400px] px-6 py-24">
        <div className="overflow-hidden rounded-[40px border
          border-cottage-border bg-white shadow-2xl">

          {/* Header */}
          <div className="flex flex-col gap-3 bg-cottage-primary px-8
            py-8 text-white md:flex-row md:items-center md:justify-between">

            <div>
              <p className="text-sm uppercase tracking-[0.3em] text-cottage-highlight">
                Home Financing
              </p>

              <h2 className="mt-3 font-heading text-4xl">
                Mortgage Payment Calculator
              </h2>
            </div>

            <FontAwesomeIcon
              icon={faChartLine}
              className="text-5xl text-cottage-highlight"
            />
          </div>

          <iframe
            src="https://www.mortgagecalculator.org/webmasters/?downpayment=80000&homevalue=400000&loanamount=320000&interestrate=7&loanterm=30&propertytax=2700&pmi=1&homeinsurance=1500&monthlyhoa=0"

            className="h-[2400px] w-full border-0 md:h-[1200px]"
            scrolling="no"
            title="Mortgage Calculator"
          />
        </div>
      </motion.section>
    </>
  );
}